module.exports = __webpack_public_path__ + "img/foodSafety-bannerBugs.323c9dd9.png";